import { css } from 'styled-components';

export const detailsRichText = css`
  & details {
    padding-bottom: 16px;

    &[open] {
      display: flex;
      flex-direction: column;
    }

    &[open] > summary {
      order: 1;
    }

    & > summary {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      font-weight: 700;
      list-style: none;
      line-height: 20px;
      font-size: 14px;

      &::-webkit-details-marker {
        display: none;
      }

      &::after {
        content: '\\ea55';
        flex-shrink: 0;
        font-family: var(--font-icons);
        font-size: 16px;
        transform: rotate(90deg);
        transition: transform 0.2s ease;
      }

      & > .label-hide {
        display: none;
      }
    }

    &[open] > summary {
      &::after {
        transform: rotate(-90deg);
      }

      & > .label-show {
        display: none;
      }

      & > .label-hide {
        display: inline;
      }
    }

    & h4 {
      margin: 0;
      padding-bottom: 4px;
      font-size: 16px;
      line-height: 24px;
    }

    & p {
      margin: 0;
      padding-bottom: 8px;
      white-space: pre-line;
      color: ${({ theme }) => theme.blackLightColor};
    }
  }
`;
